module.exports = __webpack_public_path__ + "img/tel.56cb6a87.png";